export default "__VITE_ASSET__CcDz9O_Z__"